import clsx from 'clsx';
import { ReactNode } from 'react';

import styles from './InfoCardRow.module.scss';

type Props = {
  children: ReactNode;
  className?: string;
  'data-testid'?: string;
};

/**
 * Responsive 4-up grid of {@link InfoCard}s used by the eval detail pages
 * (meta rows, footer rows, the details-tab grid). Collapses to 2 columns on
 * narrow viewports and 1 on mobile.
 */
export function InfoCardRow( { children, className, 'data-testid': dataTestId }: Props ) {
  return (
    <div className={ clsx( styles.row, className ) } data-testid={ dataTestId }>
      { children }
    </div>
  );
}
